import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { selectCurrentCarpa } from '@core-lib/store/user-store/selectors';
import { ICarpa, ICarpaLight, IList } from '@core-lib/models';
import { AuthSharedService } from './auth.service';

@Injectable({
	providedIn: 'root'
})
export class CarpaService {
	public currentCarpa: ICarpaLight = {
		id: null,
		nom: null,
		tenantKey: null
	};

	public get currentCarpa$(): Observable<ICarpaLight> {
		return this.store$.select(selectCurrentCarpa);
	}

	constructor(
		private authService: AuthSharedService,
		private http: HttpClient,
		private store$: Store
	) {
		this.currentCarpa$.subscribe(c => (this.currentCarpa = c));
	}

	getCurrent(): Observable<ICarpa> {
		return this.http.get<ICarpa>(`${environment.apiUrl}/t/${this.authService.currentTenantKey}/carpa/current`);
	}

	getUserCarpas(): Observable<ICarpaLight[]> {
		return this.http.get<ICarpaLight[]>(`${environment.apiUrl}/user/carpas`);
	}

	loadCarpas(onlyActive: boolean): Observable<ICarpaLight[]> {
		let httpParams = new HttpParams();
		httpParams = httpParams.append('onlyActive', onlyActive);

		return this.http
			.get<IList<ICarpaLight>>(`${environment.apiUrl}/carpa`, {
				params: httpParams
			})
			.pipe(map(res => res.items));
	}
}
